export default function player() {
    if(document.querySelector(".player")) {
        let playerMobileAll = document.querySelectorAll(".player--mobile");
        let playerDesktopAll = document.querySelectorAll(".player--desktop");
        let player;

        if(window.innerWidth >= 1200) {
            playerMobileAll.forEach(playerMobile => {
                playerMobile.remove();
            });
        }

        if(window.innerWidth < 1200) {
            playerDesktopAll.forEach(playerDesktop => {
                playerDesktop.remove();
            });
        }

        //CONTROLS
        let plays = document.querySelectorAll(".play");
        let pauses = document.querySelectorAll(".pause");
        let playersMobile = document.querySelector(".mobile-players");
        let open = document.querySelector(".players__open");
        let floatButton = document.querySelector(".float-button");

        open.addEventListener("click", () => {
            playersMobile.classList.toggle("open");
            floatButton.classList.toggle("down");
        });

        playerDesktopAll.forEach(playerDesktop => {
            playerDesktop.addEventListener("click", ({ target, }) => {
                player = target.parentElement.parentElement.parentElement.parentElement.children[0];

                playerDesktopAll.forEach(player => player.classList.contains("active") && player.classList.remove("active"));

                playerDesktop.classList.add("active");

                playerDesktopAll.forEach(player => {
                    let controls = Array.from(player.children[1].children[0].children);
                    let muteds = Array.from(player.children[2].children[0].children);

                    if(!player.classList.contains("active")){
                        player.children[0].pause();
                    }

                    if(player.children[0].paused) {
                        controls[0].classList.remove("disabled");
                        controls[1].classList.add("disabled");
                    }

                    if(player.classList.contains("active")) {
                        controls.forEach(() =>  {
                            if(!controls[1].classList.contains("disabled") && !controls[0].classList.contains("disabled"))  {
                                controls[1].classList.add("disabled");
                            }
                        });

                        muteds.forEach(() => {
                            if(!muteds[1].classList.contains("disabled") && !muteds[0].classList.contains("disabled")) {
                                muteds[1].classList.add("disabled");
                            }
                        });
                    }
                });
            });
        });

        playerMobileAll.forEach(playerMobile => {
            playerMobile.addEventListener("click", ({ target, }) => {
                player = target.parentElement.parentElement.parentElement.parentElement.children[0];

                playerMobileAll.forEach(player => player.classList.contains("active") && player.classList.remove("active"));

                playerMobile.classList.add("active");

                playerMobileAll.forEach(player => {
                    let controls = Array.from(player.children[0].children[1].children[0].children);
                    let muteds = Array.from(player.children[0].children[2].children[0].children);

                    if(!player.classList.contains("active")){
                        player.children[0].children[0].pause();
                    }

                    if(player.children[0].children[0].paused) {
                        controls[0].classList.remove("disabled");
                        controls[1].classList.add("disabled");
                    }

                    if(player.classList.contains("active")) {
                        controls.forEach(() =>  {
                            if(!controls[1].classList.contains("disabled") && !controls[0].classList.contains("disabled"))  {
                                controls[1].classList.add("disabled");
                            }
                        });

                        muteds.forEach(() => {
                            if(!muteds[1].classList.contains("disabled") && !muteds[0].classList.contains("disabled")) {
                                muteds[1].classList.add("disabled");
                            }
                        });
                    }
                });
            });
        });

        plays.forEach(play => {
            play.addEventListener("click", ({ target, }) => {
                target.parentElement.parentElement.parentElement.parentElement.children[0].play();

                play.classList.add("disabled");

                pauses.forEach(pause => pause.classList.contains("disabled") && pause.classList.remove("disabled"));
            });
        });

        pauses.forEach(pause => {
            pause.addEventListener("click", ({ target, }) => {
                target.parentElement.parentElement.parentElement.parentElement.children[0].pause();

                pause.classList.add("disabled");

                plays.forEach(play => play.classList.contains("disabled") && play.classList.remove("disabled"));
            });
        });

        //MUTED
        let offMuteds = document.querySelectorAll(".off-muted");
        let onMuteds = document.querySelectorAll(".on-muted");

        offMuteds.forEach(offMuted => {
            offMuted.addEventListener("click", ({ target, }) => {
                target.parentElement.parentElement.parentElement.parentElement.children[0].volume = 0;

                offMuted.classList.add("disabled");

                onMuteds.forEach(onMuted => onMuted.classList.contains("disabled") && onMuted.classList.remove("disabled"));
            });
        });

        onMuteds.forEach(onMuted => {
            onMuted.addEventListener("click", ({ target, }) => {
                target.parentElement.parentElement.parentElement.parentElement.children[0].volume = 1;

                offMuteds.forEach(offMuted => offMuted.classList.contains("disabled") && offMuted.classList.remove("disabled"));
            });
        });

        //PROGRESS
        // let progress = document.querySelector(".progress__bar");

        // player.addEventListener("timeupdate", () => {
        //     progress.style.width = `${(player.currentTime + .25) / player.duration * 100}%`;
        // });

        // if(document.querySelector(".player__time")) {
        //     let timeProgress = document.querySelector(".player__time p");

        //     player.addEventListener("timeupdate", () => {
        //         let minute = Math.floor(player.currentTime / 60);
        //         let formatMinute = minute < 10 ? `0${minute}` : `${minute}`;
    
        //         let second = Math.floor(player.currentTime % 60);
        //         let formatSecond = second < 10 ? `0${second}` : `${second}`;
    
        //         timeProgress.textContent = `${formatMinute}:${formatSecond}`
        //     });
        // }
    }
}
